import { ChatblkFeedbackEvent, ChatblkMfeFunction, ChatblkUiEvent } from '.';

export const telemetryFunctionMap = ChatblkMfeFunction;
export interface ChatBLKFeedbackEvent
    extends Omit<
        ChatblkFeedbackEvent.AsObject,
        | 'feedbackSubmitTime'
        | 'responseDuration'
        | 'actualQuestionCategory'
        | 'chatblkAnswerQuality'
        | 'relatedQuestionsQuality'
        | 'chatblkFeedbackNotificationType'
        | 'wrongAnswerSelectionsList'
    > {
    feedbackSubmitTime: string;
    responseDuration: string;
    actualQuestionCategory: string;
    chatblkAnswerQuality: string;
    relatedQuestionsQuality: string;
    chatblkFeedbackNotificationType: string;
    wrongAnswerSelections: Array<string>;
}

export interface GenericInterface<T> {
    [key: string]: T;
}

export interface ChatBLKUiEvent
    extends Omit<
        ChatblkUiEvent.AsObject,
        'chatblkLaunchMode' | 'chatblkFunction' | 'optionsMap' | 'eventTime'
    > {
    chatblkLaunchMode: string;
    chatblkFunction: string;
    eventTime?: string;
    options: GenericInterface<string>;
}

export interface ChatBLKResizeEvent {
    newWidth: number;
}

export interface ChatBLKToggleEvent {
    action: 'open' | 'close';
    summarize?: boolean;
    relatedQuestion?: string;
    relatedQuestionId?: string;
}

export interface ChatBlkTokenStatusEvent {
    status: 'generated' | 'expired' | 'failed';
    hasToken: boolean;
}

export interface ChatBlkUserStatusEvent {
    status: number; // 200 for success, 401 for unauthorized, etc.
}

export interface ChatBLKFeedbackApiRequest {
    id: string;
    chatblkFeedbackEvent: ChatBLKFeedbackEvent;
}

export interface ChatBLKUiEventApiRequest {
    id: string;
    chatblkUiEvent: ChatBLKUiEvent;
}
